import { css, styled } from "styled-components";

import { breakpoints } from "common/styles";

export const SidePanelContainer = styled.div`
  padding: 1rem 0;

  @media ${breakpoints.medium} {
    padding: 1rem;

    ${({ theme }) => css`
      background-color: ${theme.colors.backgroundSecondary};
      border: ${theme.borders.box};
      box-shadow: ${theme.shadows.box};
    `}
  }
`;
